import axios from './Api';

export function GetAssociationsFromMonth(month: number | string = '') {
  return axios.get<Partner.IPartner[]>(`/accounts/aids/${month}`);
}

export function GetLocalities() {
  return axios.get<Locality.ILocality[]>('/accounts/me/localities');
}

export function GetMe() {
  return axios.get<Account.IAccount>('/accounts/me/');
}

export function GetLogo() {
  return axios.get<Utils.ILogo>('/accounts/me/logo', { responseType: 'blob' });
}

export function DeleteLogo() {
  return axios.delete('/accounts/me/logo');
}

export function UpdateAccount(id = 0, data = {} as UserAccount.IState) {
  return axios.put<Axios.IResponseSuccess>(`/accounts/${id}`, data);
}

export function ChangePassword(data = {} as Account.IPasswordChange) {
  return axios.put<Axios.IResponseSuccess>('/accounts/changePassword', data);
}

export function UpdateAccountLogo(data: FormData = new FormData(), options = {} as Axios.IOptions) {
  return axios.post<Axios.IResponseSuccess>('/accounts/me/logo', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: options.onUploadProgress
  });
}
